<template>
  <div class="myhome-app">
    <HeaderCenterMain
      v-if="user.authenticated"
      :show-main="showHeaderCenterMain"
      :user="user"
      :profile-url="profileUrl"
    />
    <VideoModal
      v-if="false && loaded && introModalVisible && (user.teacher || user.student || user.parent)"
      :user="user"
      :visible="introModalVisible"
      @close-modal="closeModal()"
    />
    <keep-alive v-if="loaded && eventsLoaded">
      <router-view
        :class="['main-container', { 'main-container-home': $route.name === 'home' }]"
        :books="books"
        :bookmarks="allBookmarks"
        :books-agent="booksAgent"
        :aed="aed"
        :children-books="childrenBooks"
        :children-aed="childrenAed"
        :user="user"
        :events="events.slice(0, 3)"
        :loaded="loaded"
        :page-limit="24"
        :personal-area-logo-list="personalAreaLogoList"
        :search-endpoint="searchEndPoint"
        @open-child-book="openChildBook"
        @trigger-profile="openProfile($event)"
        @update-books-list="updateBooksNotificationState"
      ></router-view>
    </keep-alive>
    <Loader v-else-if="!errorModalVisible" class="dea-loader dea-loader--myhome" />
    <LoadingErrorModal v-if="errorModalVisible" :visible="errorModalVisible" />
    <BottomBar
      v-if="!user.agent"
      :user="user"
      :loaded="loaded"
      :books-count="books.length"
      :events-count="events.length"
      :profile-url="profileUrl"
    />
  </div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions, mapGetters } from "vuex";

import LoginMixin from "@/components/mixins/login";
import Loader from "@/components/elements/Loader";
import HandleWindowResize from "@/components/mixins/handleWindowResize";
import variables from "@/styles/variables.scss";
import logoAltro from "~/assets/AP_logo_esteso_altro.svg";
import logoDocente from "~/assets/AP_logo_esteso_docente.svg";
import logoGenitore from "~/assets/AP_logo_esteso_famiglie.svg";
import logoStudente from "~/assets/AP_logo_esteso_studente.svg";
import notAuthLogo from "~/assets/AP_logo_esteso_grigio_chiaro.svg";
// eslint-disable-next-line import/no-webpack-loader-syntax
import baseCompactApLogo from "!svg-inline-loader!@/assets/logo/dea/home-logo-light-grey.svg";
import BottomBar from "~/components/shared/BottomBar";
import VideoModal from "../components/VideoModal";
import LoadingErrorModal from "../components/LoadingErrorModal";
import HeaderCenterMain from "../components/HeaderCenterMain.vue";

export default {
  name: "MyHome",
  components: {
    BottomBar,
    Loader,
    VideoModal,
    LoadingErrorModal,
    HeaderCenterMain,
  },
  mixins: [LoginMixin, HandleWindowResize],
  props: {
    mainLogos: {
      type: Array,
      default: () => [],
    },
    showModalError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      aed: [],
      books: [],
      booksAgent: [],
      childrenBooks: {},
      childrenAed: {},
      events: [],
      loaded: false,
      eventsLoaded: false,
      showMenu: false,
      introModalVisible: false,
      errorModalVisible: this.showModalError,
      notAuthLogo,
      baseCompactApLogo,
      sourceBooks: [],
      showHeaderCenterMain: true,
    };
  },
  computed: {
    ...mapGetters(["allBookmarks", "filterNotifications", "filterRegistrations", "registrationsLoaded"]),
    degreesList() {
      return this.$root.asyncConf.degrees_json || [];
    },
    searchEndPoint() {
      if (this.$root.asyncConf) {
        return this.$root.asyncConf.searchApi;
      }
      return "";
    },
    personalAreaLogoList() {
      const personalAreaUserLogo = {
        ariaLabel: "Logo Area Personale",
        pictureClass: {
          transparent: "logo-area-personale--transparent",
          desktop: "logo-area-personale--desktop",
          mobile: "logo-area-personale--wmobile",
        },
        screenSize: {
          transparent: notAuthLogo,
          desktop: notAuthLogo,
          mobile: baseCompactApLogo,
        },
        logoClass: `dea-aplogo-fill-${this.user.targetCss.colorMod}`,
        url: this.$root.config.myhome_url,
      };
      const logosList = [...this.$root.config.logos];
      logosList.push(personalAreaUserLogo);
      return logosList;
    },
    personalAreaLogo() {
      let logo;
      if (this.user.teacher) {
        logo = logoDocente;
      } else if (this.user.student) {
        logo = logoStudente;
      } else if (this.user.parent) {
        logo = logoGenitore;
      } else if (this.user.generic) {
        logo = logoAltro;
      } else {
        logo = notAuthLogo;
      }
      return logo;
    },
    profileUrl() {
      let url = this.$root.config.profile_generic_url;
      if (this.user.teacher) {
        url = this.$root.config.profile_teacher_url;
      }
      if (this.user.student) {
        url = this.$root.config.profile_student_url;
      }
      if (this.user.parent) {
        url = this.$root.config.profile_parent_url;
      }
      if (this.user.principal) {
        url = this.$root.config.profile_principal_url;
      }
      return `${url}?url=${encodeURIComponent(document.location.href)}`;
    },
  },
  watch: {
    "trigger": function() {
      this.getData();
    },
    "$store.state.registrations.registrationsLoaded": function() {
      this.getUserEvents();
    },
    "$route": function updatedRoute(to) {
      this.showMenu = false;

      if (to.name === "home") {
        this.showHeaderCenterMain = true;
      } else {
        this.showHeaderCenterMain = false;
      }
    },
    "user": function() {
      if (this.user && this.user.id) {
        const videoLaunchCookie = this.$cookies.get(`presentazione-${this.user.id}`);
        this.introModalVisible = !videoLaunchCookie;
        this.$store.commit("setUser", this.user, false);
      }
    },
    "showModalError": function(value) {
      this.errorModalVisible = value;
    },
    "windowWidth": function(value) {
      if (this.$route.name === "home") {
        if (value <= variables.bpSizeLarge) {
          this.showHeaderCenterMain = false;
        } else {
          this.showHeaderCenterMain = true;
        }
      } else {
        this.showHeaderCenterMain = false;
      }
    },
  },
  created() {
    window.addEventListener("orientationchange", () => {
      this.showMenu = false;
    });
  },
  mounted() {
    if (this.user.authenticated) {
      this.getData();
    }
    if (this.$route.name === "home" && this.windowWidth > variables.bpSizeLarge) {
      this.showHeaderCenterMain = true;
    } else {
      this.showHeaderCenterMain = false;
    }
    window.addEventListener("scroll", this.toggleHeader);
  },
  destroyed() {
    window.removeEventListener("scroll", this.toggleHeader);
  },
  methods: {
    ...mapActions(["fetchMessages"]),
    toggleHeader() {
      setTimeout(() => {
        if (window.scrollY < 60 && this.$route.name === "home" && this.windowWidth > variables.bpSizeLarge) {
          this.showHeaderCenterMain = true;
        } else {
          this.showHeaderCenterMain = false;
        }
      }, 300);
    },
    /**
     * Fetch books / activations for a user child
     *
     * @param id: child username
     */
    getChildrenBooks(id) {
      fetch(`${this.$root.config.activationsURL}?user=${id}`, { headers: this.buildHeaders() })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Error connecting to the API", response);
        })
        .then(data => {
          this.$set(this.childrenBooks, id, data.books);
          this.$set(this.childrenAed, id, data.aed);
          this.loaded = true;
        })
        .catch(response => {
          Sentry.captureException(response);
        });
    },
    /**
     * Add to each book the list of ebooks included in its activations.
     *
     * Extra attributes:
     *
     * - ebooks: list of ebook objects included in the book
     * - bSmartIds: list of the bsmart id of the ebooks
     *
     * @param  {Array} books Array of book objects as returned by the endpoint
     * @return {Array} Array of patched books with additional attributes
     */
    patchBooksData(books) {
      const data = [];
      books.forEach(book => {
        const patchedBook = { ...book };
        const ebooks = {};
        const { badgeType, notifications } = this.filterNotifications("myHomeBookBadge", `${book.time_id}`);
        book.activations.forEach(activation => {
          if (activation.ebooks.length)
            activation.ebooks.forEach(ebook => {
              const cloned = { ...ebook };
              cloned.time_id = book.time_id;
              if (badgeType) {
                cloned.badgeType = badgeType;
                cloned.notifications = notifications;
              }
              ebooks[ebook.bsmart_id] = cloned;
            });
        });
        patchedBook.ebooks = Object.values(ebooks);
        patchedBook.bSmartIds = patchedBook.ebooks.map(ebook => ebook.bsmart_id);
        if (badgeType) {
          patchedBook.badgeType = badgeType;
          patchedBook.notifications = notifications;
        }
        data.push(patchedBook);
      });

      return data;
    },
    /**
     * Fetch user books / activations
     */
    getUserBooks() {
      fetch(`${this.$root.config.activationsURL}`, { headers: this.buildHeaders() })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Error connecting to the API", response);
        })
        .then(data => {
          this.aed = data.aed;
          this.sourceBooks = [...data.books];
          this.updateBooksNotificationState();
          if (!this.user.children_map || !this.user.children_map.length) {
            this.loaded = true;
          }
        })
        .catch(response => {
          Sentry.captureException(response);
          this.errorModalVisible = true;
        });
    },
    /**
     * Get latest events from vuex state
     */
    getUserEvents() {
      if (!this.user.student && !this.user.parent) {
        this.events = this.filterRegistrations("future");
        this.eventsLoaded = true;
      } else {
        this.events = [];
        this.eventsLoaded = true;
      }
    },
    /**
     * Fetch books for agent user.
     */
    getAgentBooks() {
      const secondaryNewBooks = `${this.$root.config.newBooksURL}secondaria/`;
      fetch(secondaryNewBooks, { headers: this.buildHeaders() })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Error connecting to the API", response);
        })
        .then(data => {
          this.booksAgent = this.degreesList.map(deg => {
            // eslint-disable-next-line no-param-reassign
            deg.books = data.results.filter(el => el.degrees.length && el.degrees[0].id === deg.id);
            return deg;
          });
          this.loaded = true;
          this.eventsLoaded = true;
        })
        .catch(response => {
          Sentry.captureException(response);
        });
    },
    /**
     * General entry point for loading data.
     *
     * This is called after the user has been loaded and we thus have a valid user at `this.user`
     */
    async getData() {
      if (!this.user.authenticated) {
        document.title = "Area Personale";
        this.errorModalVisible = true;
      } else {
        Sentry.setUser({ username: this.user.id, ip_address: "{{ auto }}" });
        document.title = `Area Personale - ${this.user.firstname}`;
        if (this.$root.config.messages.enable) await this.fetchMessages({ user: this.user });
        if (this.user.agent) {
          this.getAgentBooks();
        } else {
          this.getUserBooks();
          this.getUserEvents();
          if (this.user.children_map) {
            // eslint-disable-next-line no-restricted-syntax
            for (const child in this.user.children_map) {
              // load books for each child
              if (Object.prototype.hasOwnProperty.call(this.user.children_map, child)) this.getChildrenBooks(child);
            }
          }
        }
      }
    },
    closeModal() {
      this.$cookies.set(`presentazione-${this.user.id}`, "true");
      this.introModalVisible = false;
    },
    updateBooksNotificationState() {
      this.books = this.patchBooksData(this.sourceBooks);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "~/scss/_local-variables"; //sass-lint:disable-line clean-import-paths

$header-center-main-top: $dea-header-top-height;
$header-center-main-top-mobile: 0;
$main-container-top: 66px;
$loader-home-padding-top: 200px;

.main-container {
  @include media("<s") {
    top: $header-center-main-top-mobile;
  }

  position: relative;
  top: $main-container-top;

  &-home {
    @include media("<=m") {
      top: $header-center-main-top-mobile;
    }

    top: $header-center-main-top;
  }
}

.dea-links--chip {
  padding: 0 $space-base;

  &:first-of-type {
    padding-left: 0;
  }
}

.dea-links__label--chip {
  min-width: auto;
}

.dea-chip--inline {
  border-radius: $border-radius-circle;
  display: inline-block;
  margin-left: $space-x-small;
  min-width: $dea-size-medium;
  padding: 0 1px 0 0;

  .dea-chip__label {
    transform: none;
  }
}

.dea-loader--myhome {
  padding: $loader-home-padding-top 0;
}

.empty-book-section__buttons {
  .dea-button {
    display: inline-flex;
  }
}

.dea-main-header__dea-logo--personal-area {
  align-items: center;

  .header-center-main__area-personale-logo {
    height: $space-base;
    transform: none;
  }
}
</style>
